<template>
  <a-table class="stripped table-hover" :columns="columns" :data-source="data" :row-selection="rowSelection"
    :pagination="false">
    <template #bodyCell="{ column, record }">
      <!-- Subject Column -->
      <template v-if="column.key === 'subject'">
        <router-link :to="{ path: '/crm/edit-support-case', query: { caseId: record.key } }"
          class="profile-split d-flex flex-column hover-link text-wrap"
          style="white-space: normal; word-break: break-word;">
          {{ record.subject }}
        </router-link>
      </template>

      <!-- Status Column -->
      <template v-else-if="column.key === 'status'">
        <span v-if="record.status === 'New'" class="px-2 py-1 rounded"
          style="background-color: #eeeeee; color: #6a6a6a;">
          {{ record.status }}
        </span>
        <span v-if="record.status === 'Assigned'" class="px-2 py-1 rounded"
          style="background-color: #ecf5fd; color: #5b9aca;">
          {{ record.status }}
        </span>
        <span v-if="record.status === 'Pending'" class="px-2 py-1 rounded"
          style="background-color: #fbf7e1; color: #9E7328;">
          {{ record.status }}
        </span>
        <span v-if="record.status === 'Closed'" class="px-2 py-1 rounded"
          style="background-color: #dbf0de; color: #419b50;">
          {{ record.status }}
        </span>
        <span v-if="record.status === 'Rejected'" class="px-2 py-1 rounded"
          style="background-color: #d7657d; color: white;">
          {{ record.status }}
        </span>
        <span v-if="record.status === 'Duplicate'" class="px-2 py-1 rounded"
          style="background-color: #ece7f9; color: #83779c;">
          {{ record.status }}
        </span>
      </template>

      <!-- Priority Column -->
      <template v-else-if="column.key === 'priority'">
        <span v-if="record.priority === 'High'" class="px-2 py-1 rounded"
          style="background-color: #e4a133; color: white;">
          {{ record.priority }}
        </span>
        <span v-else-if="record.priority === 'Urgent'" class="px-2 py-1 rounded"
          style="background-color: #d7657d; color: white;">
          {{ record.priority }}
        </span>
        <span v-else>{{ record.priority }}</span>
      </template>

      <!-- Action Column -->
      <template v-else-if="column.key === 'action'">
        <div class="icon-field">
          <router-link :to="{ path: '/crm/edit-support-case', query: { caseId: record.key } }"
            class="btn table_action_btn">
            <i class="ti ti-edit"></i> Edit
          </router-link>
          <!-- <a class="btn table_action_btn mx-2" href="javascript:void(0);" @click="confirmDelete(record.key)">
            <i class="ti ti-trash text-danger"></i> Delete
          </a> -->
        </div>
      </template>
    </template>
  </a-table>
  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
  </div>


  <div class="modal-backdrop fade show" v-if="showDeleteModal"></div>
  <div v-if="showDeleteModal" class="modal custom-modal fade show" style="display: block;" tabindex="-1" role="dialog"
    aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <button class="btn-close" @click="showDeleteModal = false" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="success-message text-center">
            <div class="success-popup-icon">
              <i class="ti ti-trash-x"></i>
            </div>
            <h3>Delete Case</h3>
            <p class="del-info">Are you sure you want to delete?</p>
            <div class="col-lg-12 text-center modal-btn">
              <button class="btn btn-light" @click="showDeleteModal = false">Cancel</button>
              <button class="btn btn-danger" @click="deleteCase(selectedUserId)">Yes, Delete it</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {
  ref,
  onMounted,
  computed
} from 'vue';
import {
  useStore
} from "vuex";
import {
  useRouter,
  useRoute
} from 'vue-router';
import {
  message
} from "ant-design-vue";
import moment from 'moment';
const columns = [{
  title: "Title",
  dataIndex: "subject",
  key: "subject",
  sorter: {
    compare: (a, b) => {
      a = a.subject;
      b = b.subject;
      return a > b ? -1 : b > a ? 1 : 0;
    },
  },
},
{
  title: "Number",
  dataIndex: "ticket_number",
  key: "ticket_number",
  sorter: {
    compare: (a, b) => {
      a = a.ticket_number;
      b = b.ticket_number;
      return a > b ? -1 : b > a ? 1 : 0;
    },
  },
},
{
  title: "Status",
  dataIndex: "status",
  key: "status",
  sorter: {
    compare: (a, b) => {
      a = a.status;
      b = b.status;
      return a > b ? -1 : b > a ? 1 : 0;
    },
  },
},
{
  title: "Priority",
  dataIndex: "priority",
  key: 'priority',
  sorter: {
    compare: (a, b) => {
      a = a.priority;
      b = b.priority;
      return a > b ? -1 : b > a ? 1 : 0;
    },
  },
},
{
  title: "Type",
  dataIndex: "type",
  key: 'type',
  sorter: {
    compare: (a, b) => {
      a = a.type;
      b = b.type;
      return a > b ? -1 : b > a ? 1 : 0;
    },
  },
},
{
  title: "Created On",
  dataIndex: "created_at",
  key: 'created_at',
  sorter: {
    compare: (a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateB - dateA;
    },
  },
},

{
  title: "Action",
  dataIndex: "Action",
  key: "action",
},
];
export default {
  props: {
    searchQuery: String,
    filters: Object,
  },
  data() {
    return {
      columns,
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      rowSelection: {
        onChange: () => { },
        onSelect: () => { },
        onSelectAll: () => { },
      },
    };
  },

  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const data = ref([]);
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });

    const showDeleteModal = ref(false);
    const selectedUserId = ref(null);

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const fetchCases = async (page) => {
      if (typeof page === 'number' && Number.isFinite(page)) {
         pagination.value.current = page;
      }
      const params = {
        search: props.searchQuery,
        // date_filter: props.filters.timeFrame,
        page: pagination.value.current,
        pageSize: pagination.value.pageSize,
        status: props.filters?.status,
        priority: props.filters?.priority,
        type: props.filters?.type,
        start_date: formateDate(props.filters?.date?.[0]),
        end_date: formateDate(props.filters?.date?.[1]),
      };
      const response = await store.dispatch('suppportCases/fetchCases', params);
      if (response) {
        data.value = response.data.map((res) => ({
          key: res.id,
          subject: capitalizeFirst(res.subject),
          priority: capitalizeFirst(res.priority),
          status: capitalizeFirst(res.status),
          type: capitalizeFirst(res.type),
          ticket_number: res.ticket_number,
          created_at: moment(res.created_at).format('YYYY-MM-DD'),
        }));
        pagination.value.total = response.total;
      }
    };

    const capitalizeFirst = (str) => {
      return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
    }

    const handleTableChange = (current, pageSize) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchCases();
    };

    const confirmDelete = (id) => {
      selectedUserId.value = id;
      showDeleteModal.value = true;
    };

    const deleteCase = async (id) => {
      try {

        const response = await store.dispatch('suppportCases/deleteCase', id);

        if (response.status) {
          message.success("Case deleted successfully!");
          showDeleteModal.value = false;
          fetchCases();
        } else {
          message.error("Failed to delete Case.");
        }
      } catch (error) {
        console.error("Error deleting User:", error);
        message.error("Error deleting User.");
      }
    };

    const formateDate = (dateString) => {
      let date
      if (!dateString) {
        date = new Date(props.date?.[0])
      } else {
        date = new Date(dateString);
      }
      if (isNaN(date.getTime())) {
        return null;
      }

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');

      const formattedDate = `${yyyy}-${mm}-${dd}`;
      return formattedDate;
    };

    onMounted(async () => {
      await fetchCases();
    });

    // watchEffect(() => {
    //   fetchCases();
    // });

    return {
      data,
      pagination,
      fetchCases,
      handleTableChange,
      pageSizeOptions,
      confirmDelete,
      selectedUserId,
      showDeleteModal,
      deleteCase
    };
  },
};
</script>
<style>
.hover-link {
  color: #6092d0;
  font-weight: 600;
}

.hover-link:hover {
  text-decoration: underline;
  transition: all 0.2s ease;
}
</style>